import {
  ADD_RATERS_TYPE,
  EDIT_RATERS_TYPE,
  LIST_RATERS_TYPE,
  VIEW_RATERS_TYPE,
  DELETE_RATERS_TYPE,
  // text
  ADD_RATERS_TYPE_TEXT,
  EDIT_RATERS_TYPE_TEXT,
  LIST_RATERS_TYPE_TEXT,
  VIEW_RATERS_TYPE_TEXT,
  DELETE_RATERS_TYPE_TEXT,
  RATERS_TYPE_SUCCESS,
  RATERS_TYPE_ERROR,

} from "./actionTypes"

// add  RatersType
export const addRatersType = (data, history, callback) => {
  return {
    type: ADD_RATERS_TYPE,
    payload: { data, history, callback }
  }
}

// edit  RatersType
export const editRatersType = (data, id, callback) => {
  return {
    type: EDIT_RATERS_TYPE,
    payload: { data, id, callback },
  }
}

// list  RatersType
export const listRatersType = (data, callback) => {
  return {
    type: LIST_RATERS_TYPE,
    payload: { data, callback },
  }
}

// view  RatersType
export const viewRatersType = (data, history) => {
  return {
    type: VIEW_RATERS_TYPE,
    payload: { data, history },
  }
}

// delete  RatersType
export const deleteRatersType = (data, callback) => {
  return {
    type: DELETE_RATERS_TYPE,
    payload: { data, callback },
  }
}

// text
// add  RatersType text
export const addRatersTypeText = (data, history, callback) => {
  return {
    type: ADD_RATERS_TYPE_TEXT,
    payload: { data, history, callback }
  }
}

// edit  RatersType text
export const editRatersTypeText = (data, id, callback) => {
  return {
    type: EDIT_RATERS_TYPE_TEXT,
    payload: { data, id, callback },
  }
}

// list  RatersType text
export const listRatersTypeText = (data, id, callback) => {
  return {
    type: LIST_RATERS_TYPE_TEXT,
    payload: { data, id, callback },
  }
}

// view  RatersType text
export const viewRatersTypeText = (data, history) => {
  return {
    type: VIEW_RATERS_TYPE_TEXT,
    payload: { data, history },
  }
}

// delete  RatersType text
export const deleteRatersTypeText = (data, callback) => {
  return {
    type: DELETE_RATERS_TYPE_TEXT,
    payload: { data, callback },
  }
}

export const ratersTypeSuccess = message => {
  return {
    type: RATERS_TYPE_SUCCESS,
    payload: message,
  }
}

export const ratersTypeError = message => {
  return {
    type: RATERS_TYPE_ERROR,
    payload: message,
  }
}
